/*
 * Recipe-page lead capture — Klaviyo subscribe + identify + Saved Recipe + GA4.
 *
 * Reads Klaviyo config from window.AurumAsh.klaviyo (rendered by layout/theme.liquid).
 * Reads localized strings from data-string-* attributes on the section.
 */
(function () {
  'use strict';

  function init() {
    var section = document.querySelector('[data-recipe-lead]');
    if (!section) return;
    var form = section.querySelector('[data-recipe-lead-form]');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      handleSubmit(section, form);
    });
  }

  function handleSubmit(section, form) {
    var emailInput = form.querySelector('input[name="email"]');
    var email = (emailInput.value || '').trim();
    if (!email) return;

    var btn = form.querySelector('button[type="submit"]');
    var messageEl = section.querySelector('[data-recipe-lead-message]');
    var strings = {
      button: section.dataset.stringButton,
      sending: section.dataset.stringSending,
      success: section.dataset.stringSuccess,
      error: section.dataset.stringError
    };

    btn.disabled = true;
    btn.textContent = strings.sending;
    messageEl.hidden = true;
    messageEl.textContent = '';
    messageEl.classList.remove('aa-recipe-lead__message--success', 'aa-recipe-lead__message--error');

    var recipe = {
      handle: section.dataset.recipeHandle,
      title: section.dataset.recipeTitle,
      method: section.dataset.recipeMethod,
      spirit: section.dataset.recipeSpirit,
      type: section.dataset.recipeType,
      image: section.dataset.recipeImage || '',
      url: section.dataset.recipeUrl || ''
    };

    subscribeToList(email)
      .then(function () {
        fireDownstream(email, recipe);
        showSuccess(form, messageEl, strings.success);
      })
      .catch(function (err) {
        console.error('[lead-capture]', err);
        btn.disabled = false;
        btn.textContent = strings.button;
        showError(messageEl, strings.error);
      });
  }

  function subscribeToList(email) {
    var cfg = (window.AurumAsh && window.AurumAsh.klaviyo) || {};
    if (!cfg.companyId || !cfg.newsletterListId) {
      return Promise.reject(new Error('Klaviyo not configured (companyId or newsletterListId missing)'));
    }

    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'recipe_lead_capture',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: { recipe_subscribed: true }
              }
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: cfg.newsletterListId } }
        }
      }
    };

    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.companyId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-10-15'
      },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (res.status === 202 || res.ok) return;
      return res.text().then(function (t) {
        throw new Error('Klaviyo subscribe failed (' + res.status + '): ' + t);
      });
    });
  }

  function fireDownstream(email, recipe) {
    if (window._learnq) {
      window._learnq.push(['identify', {
        $email: email,
        recipe_subscribed: true
      }]);
      window._learnq.push(['track', 'Saved Recipe', {
        RecipeHandle: recipe.handle,
        RecipeTitle: recipe.title,
        RecipeType: recipe.type,
        SpiritCategory: recipe.spirit,
        Method: recipe.method,
        ImageUrl: recipe.image,
        RecipeUrl: recipe.url
      }]);
    }
    if (window.gtag) {
      window.gtag('event', 'generate_lead', {
        creative_slot: 'recipe_lead_capture',
        recipe_handle: recipe.handle,
        recipe_method: recipe.method,
        recipe_url: recipe.url
      });
    }
    if (window.Shopify && window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish('aurum_ash:lead_captured', {
        email: email,
        recipeHandle: recipe.handle,
        recipeTitle: recipe.title,
        recipeType: recipe.type,
        recipeMethod: recipe.method,
        spiritCategory: recipe.spirit,
        recipeUrl: recipe.url,
        imageUrl: recipe.image
      });
    }
  }

  function showSuccess(form, messageEl, text) {
    form.hidden = true;
    messageEl.textContent = text;
    messageEl.hidden = false;
    messageEl.classList.add('aa-recipe-lead__message--success');
  }

  function showError(messageEl, text) {
    messageEl.textContent = text;
    messageEl.hidden = false;
    messageEl.classList.add('aa-recipe-lead__message--error');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
